const randomStringCharList: string = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const generateRandomString = (length: number = 15): string => {
    let result = "";
    for (let i = length; i > 0; --i) {
        result += randomStringCharList[Math.floor(Math.random() * randomStringCharList.length)];
    }
    return result;
};
